export default {
    common: {
        logout: "退出登录",
        profile: "个人中心",
        register: "注册",
        login: "登录",

        login_guide: {
            login_now: "立即登录",
            not_login: "未登录",
            sub_text: "请登录以使用更多功能",
        },
        // 专业版有效期至
        vip_expire: "专业版有效期至：{date}",
    },
};
